<div class="w-30rem">
  <ui-card>
    <div class="w-full flex flex-column gap-3">
      <div class="flex flex-column align-items-center justify-content-center gap-3">
        <img src="assets/Novatellus.svg" alt="Novatellus" class="w-12rem max-w-full h-auto" />
        <span class="text-2xl font-bold">Recupera password</span>
        <span class="text-sm text-center" *ngIf="!sentMessage">
          Inserisci la tua email per ricevere il link di ripristino.
        </span>
      </div>

      <!-- Richiesta inviata: il backend risponde sempre allo stesso modo, che
           l'email esista o no, per non rivelare quali indirizzi sono registrati. -->
      <ng-container *ngIf="sentMessage">
        <div class="text-sm text-center">{{ sentMessage }}</div>
        <div class="text-sm text-center text-color-secondary">
          Controlla anche la cartella spam. Il link ha una validità limitata.
        </div>
        <p-button
          type="button"
          label="Invia di nuovo"
          [outlined]="true"
          styleClass="w-full"
          (onClick)="reset()"
        ></p-button>
      </ng-container>

      <form
        *ngIf="!sentMessage"
        #forgotPasswordForm="ngForm"
        (ngSubmit)="onSubmit(forgotPasswordForm)"
        class="w-full flex flex-column gap-3"
      >
        <span class="w-full flex flex-column gap-2">
          <label for="email">Email*</label>
          <input
            id="email"
            type="email"
            pInputText
            name="email"
            [(ngModel)]="email"
            required
            email
            autocomplete="email"
            class="w-full"
          />
        </span>

        <div *ngIf="submitError" class="text-sm text-center" role="alert">{{ submitError }}</div>

        <p-button
          type="submit"
          label="Invia il link"
          [disabled]="forgotPasswordForm.invalid ?? true"
          [loading]="isSubmitting"
          styleClass="w-full"
        />
      </form>

      <span class="text-center text-sm">
        Torna alla pagina di accesso
        <p-button
          label="Login"
          [text]="true"
          size="small"
          severity="secondary"
          styleClass="underline p-0"
          [routerLink]="['/', AppRoutes.AUTH, AppRoutes.AUTH_LOGIN]"
        />
      </span>
    </div>
  </ui-card>
</div>
